const TRANSFERVIEW = {
  transferFormsCompany: "Transferência de formulários entre empresas.",
  search: "Procurar...",
  addDescription: "Adicionar descrição",
  editTask: "Editar tarefa",
  originCompany: "Empresa de origem",
  destinityCompany: "Empresa de destino",
  group: "conjunto",
  toTransfer: "Transferir",
  transfer: "Transferir",
  successTransfer: "A transferência do formulário foi realizada.",
  form: "Forma",
  typeForm: "Tipo de formulário",
  group: "Conjunto",
  Active: "Ativo",
  Closed: "Inativo",
  Deleted: "Excluído"
};

export default { TRANSFERVIEW };
